module.exports = __webpack_public_path__ + "img/pepe-coin-price-chart-coinmarketcap.1f8289ce.webp";